// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5234) return "static/chunks/5234.e2936ea2a03604bc.js";
	if (chunkId === 5090) return "static/chunks/5090.526c4f08f40d498a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"5141":"80ec0b260ebc39bd","6985":"2360e5b7a7b8c03a","9845":"883f509c2e8d2b2e"}[chunkId] + ".js";
};